import { clockOf, formatDuration } from "../format";
import type { Movie, Showtime } from "../types";

type Props = {
  movies: Movie[];
  onOpenMovie: (movie: Movie) => void;
  onOpenShowtime: (movie: Movie, showtime: Showtime) => void;
};

export function Poster({ movie, className = "poster" }: { movie: Movie; className?: string }) {
  if (!movie.poster) {
    return (
      <div className={`${className}-empty`} aria-hidden="true">
        AFFICHE
        <br />
        INDISPO.
      </div>
    );
  }
  return <img className={className} src={movie.poster} alt={`Affiche de ${movie.title}`} loading="lazy" />;
}

export function FilmList({ movies, onOpenMovie, onOpenShowtime }: Props) {
  return (
    <div className="films">
      {movies.map((movie, index) => (
        <article className="film" key={movie.slug} style={{ "--index": index } as React.CSSProperties}>
          <Poster movie={movie} />

          <div className="film-body">
            <button type="button" className="film-open" onClick={() => onOpenMovie(movie)}>
              <h2 className="film-title">{movie.title}</h2>
              <p className="film-meta">
                <span className="film-duration">{formatDuration(movie.duration)}</span>
                <span>{movie.genres.slice(0, 2).join(", ")}</span>
                <span>
                  {movie.showtimes.length} séance{movie.showtimes.length > 1 ? "s" : ""}
                </span>
              </p>
              <span className="film-cue">Voir les salles et le remplissage →</span>
            </button>

            <ul className="seances">
              {movie.showtimes.map((showtime) => (
                <li key={showtime.bookingUrl}>
                  <button
                    type="button"
                    className="seance"
                    onClick={() => onOpenShowtime(movie, showtime)}
                  >
                    <span className="seance-top">
                      <span className="seance-time">{clockOf(showtime.time)}</span>
                      <span className="tag-version">{showtime.version}</span>
                    </span>
                    <span className="seance-hall">
                      Salle {showtime.auditorium}
                      {showtime.capacity ? ` · ${showtime.capacity} pl.` : ""}
                    </span>
                    {showtime.formats.length > 0 && (
                      <span className="formats">
                        {showtime.formats.map((format) => (
                          <span className="tag-format" key={format}>
                            {format}
                          </span>
                        ))}
                      </span>
                    )}
                    {showtime.soldOut && <span className="tag-full">COMPLET</span>}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </article>
      ))}
    </div>
  );
}
